/**
 * Shared token refresh flow used by both helpers (admin apiGet/apiPost) and
 * axiosInstance (tenant). No dependency on api/axios to avoid circular imports.
 */
import { postRefreshToken } from './requests.ts';
import { clearTokens } from './storage.ts';
import { getAppPublicPathUrl } from '../../utils/tenant';
import { AUTH_PATHS } from '../../routing/paths.ts';

const REFRESH_LOCK_NAME = 'oauth-token-refresh';

const AUTH_KEYS = [
  'username',
  'userId',
  'organization_slug',
  'organization_id',
  'access_token',
  'refresh_token',
  'is_platform_admin',
  'auth_user',
];

function signOutAndRedirect(): void {
  if (typeof window === 'undefined') return;
  clearTokens();
  AUTH_KEYS.forEach((k) => {
    try {
      window.localStorage.removeItem(k);
    } catch (_) {}
  });
  window.location.replace(getAppPublicPathUrl(AUTH_PATHS.SIGNIN));
}

/**
 * Refresh access token using backend cookies (refresh token lives in httpOnly cookie).
 * On failure (e.g. refresh expired), signs out and redirects to signin.
 * Caller should retry the original request after this resolves.
 */
export async function performTokenRefresh(): Promise<void> {
  try {
    const locks = (navigator as any).locks;
    if (locks?.request) {
      await locks.request(REFRESH_LOCK_NAME, async () => {
        await postRefreshToken('');
        await new Promise((r) => setTimeout(r, 300));
      });
    } else {
      await postRefreshToken('');
    }
  } catch (e) {
    signOutAndRedirect();
    throw e;
  }
}
